import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@node_modules/@angular/router/router";
import { GMapsService } from "@shared/services/gmap/gmaps.service";
import { BaseMapModel } from "../../models/generic-map/BaseMapModel";
import { GMarker } from "@shared/models/gmap/gmarker.model";
import { BehaviorSubject } from "@node_modules/rxjs";
import { GMarkerLabel } from "@shared/models/gmap/gmarket.label.model";
import { GPolyline } from "@shared/models/gmap/gpolyline.model";

@Component({
	selector: "kt-generic-map",
	templateUrl: "./generic-map.component.html",
	styleUrls: ["./generic-map.component.scss"],
})
export class GenericMapComponent implements OnInit, AfterViewInit {
	@ViewChild("map", { static: false }) mapElement: ElementRef;
	private _map: google.maps.Map;

	@Input() mapModel: BaseMapModel;	

	constructor(private _gMapsService: GMapsService) {}

	ngOnInit() {
	}

	ngAfterViewInit(): void {
		try {
			this.initMap(); //Haritanın yüklenmesini sağlayan metot çalıştırılıyor.
			// setTimeout(() => {
			// 			this.initMap();
			// 		}, 100);
		} catch (error) {
			alert(`Bir sorun oluştu! Harita yüklenirken bir sorun oluştu. Input olarak gönderilen parametre nesnenizi kontrol edin. Hata mesajı: ${error}`);
		}
	}

	//Generate Random ID
	generateRandomId(): number {
		// 10000 ile 99999 arasında 5 haneli rastgele bir sayı üretir
		return Math.floor(10000 + Math.random() * 90000);
	}

	// initMap() GMapService'i kullanarak google.maps servisleriyle haritanın oluşturulmasını belirtilen markerların türlerine göre işaretlenmesini sağlıyor.
	initMap(): void {
		if (!this.mapElement) {
			alert("Harita yüklenirken bir sorun oluştu! Map element bulunamadı!");
		}

		const mapCenter = new google.maps.LatLng(this.mapModel.initCoordinate.latitude, this.mapModel.initCoordinate.longitude);
		const init = this._gMapsService.initMap(mapCenter, this.mapElement.nativeElement, this.mapModel.initZoom);	//Haritayı oluştur. (mapCenter haritanın merkez alacağı nokta konumudur)

		// Burada genericMap model ile harita üzerinde markerların nasıl görüntülenmesi istenildiyse 
		// buna göre service kullanılarak harita üzerinde işaretleme yapılması sağlanıyor..
		// marker | cluster | road
		switch (this.mapModel.type) {
			case "Marker":
				this._gMapsService.MarkerOperation.addMarkers(this.mapModel.markers); //default useCluster == false
				break;

			case "Cluster":
				this._gMapsService.MarkerOperation.addMarkers(this.mapModel.markers, true);
				break;

			case "Road":
				this._gMapsService.MarkerOperation.addMarkers(this.mapModel.markers, false);

				const coordinates = this.mapModel.markers.map((marker) => ({
					lat: marker.position.latitude,
					lng: marker.position.longitude,
				}));

				const gPolyline: GPolyline = {
					id: this.generateRandomId(),
					coordinates: coordinates,
					strokeColor: this.mapModel.polygonColor,
					strokeWeight: 3,
				};

				this._gMapsService.PolylineOperation.generate(gPolyline);
				break;
		}
	}
}
